import React from 'react';
import PropTypes from 'prop-types';
import MainTextField from '../../MUI/MainTextField';

import useStyles from './makeStyles';

const TextAreaField = ({ value, id, name, onChange, variant, color, multiline }) => {
  const classes = useStyles();

  return (
    <MainTextField
      className={classes.textArea}
      color={color}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      multiline={multiline}
      variant={variant}
    />
  );
};

TextAreaField.propTypes = {
  value: PropTypes.string,
  id: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.string,
  multiline: PropTypes.bool,
};

TextAreaField.defaultProps = {
  value: '',
  id: '',
  name: '',
  color: 'primary',
  variant: 'outlined',
  multiline: true,
};

export default TextAreaField;
